import React from 'react';
import PropTypes from 'prop-types';

import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip
} from 'recharts';

import { Icon } from '../Elements';

import classes from './LineChart.module.scss';

const LineChart = ({ data, onDownload, isAnimation = true, idBtnDownload }) => {
  return (
    <div className={classes.lineChartWrap}>
      {/* eslint-disable-next-line */}
      <a id={idBtnDownload} download="chart.png" />
      <button
        type="button"
        className={classes.downloadButton}
        onClick={() => onDownload(data)}
      >
        <Icon icon={'Icn_Download-1'} className={classes.iconDownload} />
      </button>
      <AreaChart
        width={720}
        height={220}
        data={data}
        margin={{
          top: 32,
          right: 32,
          left: 8,
          bottom: 20
        }}
      >
        <defs>
          <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#9A61D2" stopOpacity={0.3} />
            <stop offset="95%" stopColor="#9A61D2" stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis type="number" domain={[0, 'dataMax+1']} allowDecimals={false} />
        <Tooltip />
        <Area
          name="Выходов"
          type="monotone"
          dataKey="uv"
          stroke="#9A61D2"
          fillOpacity={1}
          fill="url(#colorUv)"
          isAnimationActive={isAnimation}
        />
      </AreaChart>
    </div>
  );
};

LineChart.propTypes = {
  data: PropTypes.array.isRequired,
  onDownload: PropTypes.func.isRequired,
  isAnimation: PropTypes.bool,
  idBtnDownload: PropTypes.string
};

export default LineChart;
